import customAxios from "./axiosConfig";

const CorrectionService = {
  create (data) {
    const api_url = window.Urls['correction-list']()
    return customAxios.post(api_url, data)
  },
  update (id, data) {
    const api_url = window.Urls['correction-detail'](id)
    return customAxios.put(api_url, data)
  },
  retrieve (id) {
    const api_url = window.Urls['correction-detail'](id);
    return customAxios.get(api_url);
  }
}

export default CorrectionService;